import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "search.icon",
  "use": "search.icon-usage",
  "viewBox": "-10300.604 -16390.604 23.207 23.207",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-10300.604 -16390.604 23.207 23.207\" id=\"search.icon\"><path d=\"M19.586,17.6H18.538l-.372-.358a8.638,8.638,0,1,0-.929.929l.358.372v1.048l6.634,6.621,1.977-1.977Zm-7.961,0A5.971,5.971,0,1,1,17.6,11.625,5.963,5.963,0,0,1,11.625,17.6Z\" transform=\"translate(-10303.604 -16393.604)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/search.icon.svg
// module id = P6f/
// module chunks = 13